import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { HdsAlert } from '@hashicorp/design-system-components/components';

/**
 *
 * `IamInvitationsAlertNoRoleWithProjects` is an alert banner for a warning
 * before inviting a principal without a role.
 *
 *
 * ```
 * <Iam::Invitations::Alert::NoRoleWithProjects />
 * ```
 *
 * @class IamInvitationsAlertNoRoleWithProjects
 *
 */
export default class IamInvitationsAlertNoRoleWithProjects extends Component {
  <template>
    <HdsAlert
      @color="highlight"
      @type="compact"
      data-test-no-role-with-projects-container
      ...attributes
      as |A|
    >
      <A.Description>
        {{t
          "components.iam.invitations.alert.no-role-with-projects.users-without-an-org-role-must-be-granted-project-access"
        }}
      </A.Description>
    </HdsAlert>
  </template>
}
